"use strict";
/**
 * InnerContentSquare
 * Leverage for cases where you need a square with content inside it.
 * The content needs to be a node so that you can style it.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InnerContentSquare = void 0;
var inner_content_square_styles_1 = require("./inner_content_square.styles");
var react_1 = __importDefault(require("react"));
var InnerContentSquare = function (props) {
    var contentInSquare = props.contentInSquare, size = props.size;
    return (react_1.default.createElement(inner_content_square_styles_1.SquareContainer, null,
        react_1.default.createElement(inner_content_square_styles_1.Square, { type: "square", size: size }),
        react_1.default.createElement(inner_content_square_styles_1.TextWrapper, null,
            react_1.default.createElement(inner_content_square_styles_1.CenterWrapper, null, contentInSquare))));
};
exports.InnerContentSquare = InnerContentSquare;
